import React from 'react';

interface CottageIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const CottageIcon: React.FC<CottageIconProps> = ({
  color = '#0098D9',
  ...props
}) => {
  return (
    <svg
      viewBox="0 0 34 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.13204 26.8474V11.4405L1.82445 13.9723L0.75 12.545L5.13204 9.20374V4.95263H6.92767V7.81004L17 0.144531L33.25 12.5695L32.1756 13.9723L28.868 11.4405V26.8474H5.13204ZM6.92767 25.0518H15.4022V18.1138H18.5978V25.0518H27.0723V10.0772L17 2.39628L6.92767 10.0772V25.0518Z"
        fill={color}
      />
    </svg>
  );
};

export default CottageIcon;
